// extracted by mini-css-extract-plugin
export default {"App":"App_App__8ByFy","content":"App_content__RBzO4","speaker-icon-container":"App_speaker-icon-container__vhnR3"};